<template>
    <v-card>
        <v-card-title id="create-pms-case-card-header" class="px-5">
            <span class="primary--text">{{ title }}</span>
            <v-spacer></v-spacer>
            <v-icon @click="preventCloseCreateCasePMS">
                mdi-close
            </v-icon>
        </v-card-title>
        


        <!-- ################################################## PAGE BY PAGE MODULES ################################################## -->

        <v-card-text class="px-5">
           <!-- <div class="ma-4">
                {{ currentPath }} <br>
                {{ formPathLogs }}
           </div> -->
            <SearchPMSTable
                v-show="currentPath === 'searchPMS'"
                @setSelectedItem="getSelectedCase($event)"
                @show:patientCaseDetails="showPatientCaseDetails($event)"
            ></SearchPMSTable>
            <PatientCaseDetails
                v-show="currentPath === 'casePMSDetails' && showPatientPMSCase"
                :patient="patientDetails"
            ></PatientCaseDetails>
            <v-form ref="caseForm" v-model="valid" lazy-validation>
                <PatientInformationForm
                    ref="patientInformationForm"
                    v-show="currentPath === 'patientCaseInformation'"
                    :form="selectedPatient.patientInformation"
                ></PatientInformationForm>
                <CaseInformationForm
                    ref="caseInformationForm"
                    v-show="currentPath === 'patientCaseInformation'"
                    :form="selectedPatient.patientInformation"
                ></CaseInformationForm>
                <FamilyHistoryForm
                    ref="familyHistoryForm"
                    v-show="currentPath === 'familyHistory'"
                    :form="selectedPatient.patientInformation"
                ></FamilyHistoryForm>
                <HealthInformationForm
                    ref="healthInformationForm"
                    v-show="currentPath === 'healthInformation'"
                    :form="selectedPatient.caseMethod"
                ></HealthInformationForm>
                <CaseMethodForm
                    ref="caseMethodForm"
                    v-show="currentPath === 'caseMethod'"
                    :form="selectedPatient.caseMethod"
                ></CaseMethodForm>

                <div v-if="currentPath == 'healthInformation'">
                    <center>
                        <span v-if="!isImagesRetrieved && !loading" style="font-weight: bold;"><i>Click below to proceed</i></span><br>
                        <h2 v-if="isImagesRetrieved">File Retrieval was Successful</h2>
                        <h2 v-if="loading">Please wait while files are being retrieved...</h2>
                        <h2 v-if="!isImagesRetrieved && !loading"><a @click="retrieveCaseImages()" class="font-weight-bold primary--text btn-lg-primary">Retrieve Case Files</a></h2>
                    </center>
                </div>

            </v-form>
        </v-card-text>

        <!-- ################################################## PAGE BY PAGE MODULES ################################################## -->


        


        <!-- ################################################## DISPLAY IF THE USER EMAIL WAS NOT FOUND IN THE DB ################################################## -->

        <div class="my-4">
            <UserNotFoundAlert
                v-if="!showUserNotFoundAlert"
                :user="selectedSearchCase.patient_details"
                @submit="userCreated($event)"
            ></UserNotFoundAlert>
        </div>

        <!-- ################################################## DISPLAY IF THE USER EMAIL WAS NOT FOUND IN THE DB ################################################## -->





        <!-- ################################################## NAVIGATION CONTROL ################################################## -->

        <v-card-actions class="d-flex justify-center pb-5">
            <v-btn v-if="currentPath !== 'searchPMS' && !(currentPath === formArrangements[0])" depressed rounded color="primary" class="px-6 mx-2" @click="removeToFormPathLogs">
                Previous
            </v-btn>

            <template v-if="currentPath !== 'casePMSDetails'">
                <v-btn v-if="currentPath === 'searchPMS' && selectedSearchCase" depressed rounded color="primary" class="px-6 mx-2" @click="checkSelectedPatientExists()">
                    Next
                </v-btn>

                <div v-if="currentPath != 'healthInformation'">
                    <v-btn v-if="currentPath !== 'searchPMS' && selectedSearchCase && !isLastFormArrangement" depressed rounded color="primary" class="px-6 mx-2" @click="goToNextFormArrangement()">
                        Next
                    </v-btn>
                </div>
                
                <div v-if="currentPath == 'healthInformation' && isImagesRetrieved">
                    <v-btn v-if="currentPath !== 'searchPMS' && selectedSearchCase && !isLastFormArrangement" depressed rounded color="primary" class="px-6 mx-2" @click="goToNextFormArrangement()">
                        Next
                    </v-btn>
                </div>

                <v-btn v-if="isLastFormArrangement" depressed rounded color="primary" class="px-6 mx-2" :loading="loading" @click="submit()">
                    Create
                </v-btn>
            </template>
        </v-card-actions>

        <!-- ################################################## NAVIGATION CONTROL ################################################## -->


         <base-confirmation-dialog v-model="showPreventClose" @cancel="showPreventClose = false" @confirm="closeCreateCasePMS">
            <h2 class="font-weight-regular text-center" style="line-height: 130%;">
                Are you sure you want to cancel creating new case? All inputs will not be saved.
            </h2>
        </base-confirmation-dialog>

    </v-card>
</template>

<script>
import moment from "moment";
import DASHBOARD_STORE from "../../store/dashboard.module";
import API from '@/api';
const Cases = API.get('Cases');
const User = API.get('User');

export default {
    components: {
        SearchPMSTable: () => import("../tables/SearchPMSTable"),
        PatientCaseDetails: () => import("./PatientCaseDetails"),
        CaseInformationForm: () => import("../forms/CaseInformationForm"),
        CaseMethodForm: () => import("../forms/CaseMethodForm"),
        FamilyHistoryForm: () => import("../forms/FamilyHistoryForm"),
        HealthInformationForm: () => import("../forms/HealthInformationForm"),
        PatientInformationForm: () => import("../forms/PatientInformationForm"),
        UserNotFoundAlert: () => import("../alerts/UserNotFoundAlert")
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    data: () => ({
        showPatientPMSCase: false,
        currentPath: null,
        formArrangements: [
            // "searchPMS" /** search pms table view*/
            //"casePMSDetails" /** pms case details view */
            "patientCaseInformation",
            "familyHistory",
            "healthInformation",
            "caseMethod"
        ],
        formPathLogs: [],
        formArrangementIndex: 0,
        patientDetails: {},
        loading: false,
        showPreventClose: false,
        showUserNotFoundAlert: true,
        valid: false
    }),

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    computed: {
        items: {
            get() { return DASHBOARD_STORE.getters['showSeachItems'] },
            set(val) { DASHBOARD_STORE.commit('setSeachItems', val) }
        },

        selectedSearchCase: {
            get() { return DASHBOARD_STORE.getters['showSelectedSearchCase'] },
            set(val) { DASHBOARD_STORE.commit('setSelectedSearchCase', val) }
        },

        selectedPatient: {
            get() { return DASHBOARD_STORE.getters['showSelectedPatient'] },
            set(val) { DASHBOARD_STORE.commit('setSelectedPatient', val) }
        },

        isImagesRetrieved: {
            get() { return DASHBOARD_STORE.getters['showIsImagesRetrieved'] },
            set(val) { DASHBOARD_STORE.commit('setIsImagesRetrieved', val) }
        },





        isLastFormArrangement: function() {
            let lastForm = this.formArrangements[this.formArrangements.length - 1];

            return this.currentPath === lastForm;
        },

        title: function() {
            if (this.currentPath === "casePMSDetails") {
                return `Patient ID: ${this.patientDetails?.PatientId || null}`
            }

            if (this.currentPath === "assignCase") {
                return "";
            }

            return "Create Case from PMS";
        }
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    methods: {
        async retrieveCaseImages() {
          this.loading = true;
          console.log("case_number here health information");
          console.log(this.$refs.caseMethodForm.form.pmsCaseNumber);
          await this.$store.dispatch('cases/getImageToken', this.$refs.caseMethodForm.form.pmsCaseNumber);
          this.isImagesRetrieved = true;
          this.loading = false;
          return false;
        },

        preventCloseCreateCasePMS() {
            let isInFormArrangements = this.formArrangements.includes(this.currentPath);
            
            if (isInFormArrangements) {
                this.showPreventClose = true;
                return;
            }

            this.closeCreateCasePMS();
            return;
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        removeToFormPathLogs() {
            let countFormPathLogs = this.formPathLogs.length;

            let findIndex = this.formArrangements.findIndex(item => item == this.currentPath);

            if (findIndex > -1) {
                this.formArrangementIndex = findIndex;
            }

            /**
             * in the first page "searchPMS"
             */
            if (countFormPathLogs == 1) return;

            if (countFormPathLogs > 1) {
                this.formPathLogs.pop();
                this.currentPath = this.formPathLogs[this.formPathLogs.length - 1];

                return;
            }

            this.formPathLogs.push("searchPMS");
            return;
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        addToFormPathLogs(currentPath) {
            if (this.currentPath === currentPath) return;

            this.currentPath = currentPath;
            this.formPathLogs.push(currentPath);
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        goToNextFormArrangement() {
            if (this.formArrangementIndex == (this.formArrangements.length)) {
                this.formArrangementIndex--;
            }

            this.addToFormPathLogs(this.formArrangements[this.formArrangementIndex]);

            this.formArrangementIndex++;
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        getSelectedCase(event) {
            console.log({ event }, "getSelectedCase");
            this.selectedSearchCase = event;
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        showPatientCaseDetails(event) {
            console.log("[event patient details]", event);
            this.showPatientPMSCase = event.show;
            this.patientDetails = event.patientDetails?.patient_details;
            this.addToFormPathLogs('casePMSDetails');
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        async submit() {
            let valid = this.$refs.caseForm.validate();

            if (valid) {
                this.loading = true;

                let patientInformationForm = this.$refs.patientInformationForm;
                let caseInformationForm = this.$refs.caseInformationForm;
                let familyHistoryForm = this.$refs.familyHistoryForm;
                let healthInformationForm = this.$refs.healthInformationForm;
                let caseMethodForm = this.$refs.caseMethodForm;

                let examination_data = null;
                if(this.selectedSearchCase.full_case_data.Examination) {
                    examination_data = this.selectedSearchCase.full_case_data.Examination.CaseOrganSystems;
                }

                let form = {
                    pms_case_number: caseMethodForm.form?.pmsCaseNumber || null,
                    ...patientInformationForm.form,
                    ...caseInformationForm.form,
                    relatives: familyHistoryForm.relatives,
                    ...healthInformationForm.form,

                    case: { 
                        ...caseMethodForm.form,
                        reason_for_encounter            : patientInformationForm.form?.reason || null,
                        case_category                   : patientInformationForm.form?.category || null,
                        case_sub_category               : patientInformationForm.form?.sub || null,                        

                        caller_role                     : this.selectedSearchCase.full_case_data.CallerRole,
                        caller_family_name              : this.selectedSearchCase.full_case_data.CallerFamilyName,
                        caller_first_name               : this.selectedSearchCase.full_case_data.CallerFirstName,
                        patient_insurance_model         : this.selectedSearchCase.full_case_data.PatientInsuranceModel,
                        provider_name                   : this.selectedSearchCase.full_case_data.ProviderName,
                        loa                             : this.selectedSearchCase.full_case_data.LOA,
                        name_of_company                 : this.selectedSearchCase.full_case_data.NameOfCompany,
                        case_origin                     : this.selectedSearchCase.full_case_data.CaseOrigin,

                        current_medication              : caseMethodForm.form?.current_medication || null,
                        notes                           : caseMethodForm.form?.notes || null,

                        preferred_datetime              : `${caseMethodForm.form.date} ${caseMethodForm.form.time}:00`,
                        patient_id                      : this.selectedSearchCase.patient_id,
                        health_concern                  : caseMethodForm.form.healthConcern,

                        isMedCertRejected               : this.selectedSearchCase.full_case_data.MedCertRejected,
                        medCaertRejectedReason          : this.selectedSearchCase.full_case_data.MCRejectedReason,
                        endorsement                     : this.selectedSearchCase.full_case_data.Endorsement,
                        isSeasonalIllness                : this.selectedSearchCase.full_case_data.IsSeasonalIllness,
                        last_menstrual_period           : this.selectedSearchCase.full_case_data.LMP,
                        companyClinic                   : this.selectedSearchCase.full_case_data.CompanyClinic,
                        referringNurse                  : this.selectedSearchCase.full_case_data.ReferringNurse,
                        historyOfPresentIllness         : this.selectedSearchCase.full_case_data.Examination.HistoryOfPresentIllness,
                        
                        caseCategoryComments            : patientInformationForm.form?.caseCategoryComments || null,

                        medicalCertificateQuantity      : this.selectedSearchCase.full_case_data.MedicalCertificateQuantity,
                        bodyTemp                        : this.selectedSearchCase.full_case_data.Examination.BodyTemp,
                        heartRate                       : this.selectedSearchCase.full_case_data.Examination.HeartRate,
                        heartRhythm                     : this.selectedSearchCase.full_case_data.Examination.HeartRhythm,
                        bloodPressure                   : this.selectedSearchCase.full_case_data.Examination.BloodPressure,
                        oxygenSaturation                : this.selectedSearchCase.full_case_data.Examination.OxygenSaturation,
                        bloodSugar                      : this.selectedSearchCase.full_case_data.Examination.BloodSugar,

                        recommendations                 : this.selectedSearchCase.full_case_data.MedicalDecisionAndManagement.Recommendations,
                        medications                     : this.selectedSearchCase.full_case_data.MedicalDecisionAndManagement.Medications,
                        diagnosis                       : this.selectedSearchCase.full_case_data.MedicalDecisionAndManagement.Diagnosis,
                        examinations                    : examination_data,

                        patientInformationForm          : patientInformationForm.form,
                        patient_allergies               : caseMethodForm.form.allergies,
                        familyHistoryForm               : familyHistoryForm.relatives,
                        healthInformationForm           : healthInformationForm.form
                    }
                };

                console.log("form_case");
                console.log(form.case);

                /* ************************************ API CALL TO PATIENT CASE BACKEND CONRTOLLER ************************************ */

                await Cases.create(form.case)
                .then(response => {
                    console.log("return data from create case TMA side");
                    console.log(response.data);
                    DASHBOARD_STORE.dispatch("setSelectedCase", response.data);
                    DASHBOARD_STORE.commit("showAssignCaseToDoctorList", true);
                })

                .catch(error => {
                    console.log("submission_error", { error });
                })

                .finally(() => {
                    console.log("submitted finally");
                    this.loading = false;
                    this.closeCreateCasePMS();
                });

                /* ************************************ API CALL TO PATIENT CASE BACKEND CONRTOLLER ************************************ */
            }
        },


        /* ################################################## METHOD SEPARATORS ################################################## */

        closeCreateCasePMS() {
            this.showPreventClose = false; //force closing of prevent close dialog

            /**
             * set default state
             */
            this.currentPath = "searchPMS";
            this.selectedSearchCase = {};
            this.selectedPatient = {};
            this.patientDetails = {};
            this.formPathLogs = [];
            this.formArrangementIndex = 0;

            DASHBOARD_STORE.commit("showCreateCasePMS", false);
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        checkSelectedPatientExists() {
            console.log(this.selectedSearchCase);
            if(this.selectedSearchCase) {
                this.checkIfSelectedCaseUserExists();

                this.prefillFormData();

                if (this.showUserNotFoundAlert) {
                    this.goToNextFormArrangement();
                }
            }
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        async checkIfSelectedCaseUserExists() {
            
            console.log("[this.selectedSearchCase]", this.selectedSearchCase);

            let params = {
                search: this.selectedSearchCase.full_case_data.PatientDetails.PatientGuid,
                field: "pms_guid",
                approach: "strict",
            };

            await User.search({ params })
                .then(async response => {
                    console.log({ response }, "checkIfSelectedCaseUserExists");

                    if (response.data.data.length) {
                        let responseUser = response.data.data[0];
                        console.log({ responseUser }, "checkIfSelectedCaseUserExists")
                        let birthdate = moment(new Date(this.selectedSearchCase?.patient_details?.Birthday));

                        let form = {
                            is_patient: 1,
                            full_name: this.selectedSearchCase?.patient_details?.full_name,
                            height: this.selectedSearchCase?.patient_details?.Height,
                            weight: this.selectedSearchCase?.patient_details?.Weight,
                            gender: this.selectedSearchCase?.patient_details?.Gender,
                            marital_status: this.selectedSearchCase?.patient_details?.CivilStatus,
                            birthdate: birthdate.isValid() ? birthdate.format("Y-MM-DD") : null,
                            mobile_number: this.selectedSearchCase?.patient_details?.MobileNumber,
                            phonenumber_options: this.selectedSearchCase?.patient_details?.phonenumber_options
                        };

                        this.selectedSearchCase.patient_id = responseUser.id;

                        // console.log({ responseUser, form })
                        this.showUserNotFoundAlert = true;

                        await User.updateUser(responseUser.id, form);

                        // this.goToNextFormArrangement();
                    } else {
                        this.showUserNotFoundAlert = false;
                    }
                })
                .catch(error => {
                    console.log({ error })
                })
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        userCreated(event) {
            console.log({ event }, "userCreated");
            if (event.success) {
                this.selectedSearchCase.patient_id = event.response.user.id;

                console.log({ selectedCase: this.selectedSearchCase }, "userCreated")

                this.showUserNotFoundAlert = true;

                this.goToNextFormArrangement();

                return;
            }

            this.currentPath = "searchPMS";
            this.showUserNotFoundAlert = false;

            return;
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        prefillFormData() {
            let details = this.selectedSearchCase.patient_details;
            // let height = this.convertHeightToFeet(details.Height);
            // let height = details.Height;
            let birthdate = moment(new Date(this.selectedSearchCase?.patient_details?.Birthday));


            /* ------------------------- PATIENT ALLERGIES ------------------------- */
            
            /*let allergies_string = [];
            details.Allergies.map(allergy => {
                allergies_string.push(allergy.Allergy+" - "+allergy.Note);
            });
            allergies_string = allergies_string.join("\n");*/

            /* ------------------------- PATIENT ALLERGIES ------------------------- */


            /* ------------------------- CASE NOTES ------------------------- */

            /*let case_notes_string = [];
            
            this.selectedSearchCase.full_case_data.CaseNotes.map(case_note => {
                case_notes_string.push(case_note.Title+" - "+case_note.NoteText);
            });

            case_notes_string = case_notes_string.join("\n");*/

            /* ------------------------- CASE NOTES ------------------------- */

            let family_history_data = null;
            family_history_data = details.FamilyHistory || null;

            let form = {};
            form = {
                patientInformation: {
                    name: this.selectedSearchCase.full_name,
                    height: details.Height || 0,
                    weight: details.Weight || 0,
                    company: this.selectedSearchCase.name_of_company || null,
                    family_history: family_history_data,
                    
                    category: this.selectedSearchCase.full_case_data.CaseCategory || null,
                    caseCategoryComments: this.selectedSearchCase.full_case_data.CaseCategoryComments || null,

                    sub: this.selectedSearchCase.full_case_data.PediatricCategory || null,
                    age: details.age || null,
                    provider: details.HealthInsurance || null,
                    reason: this.selectedSearchCase.reason_for_encounter,
                    birthdate: birthdate.isValid() ? birthdate.format("Y-MM-DD") : null,

                    email_options:                  this.selectedSearchCase.patient_details?.email_options,
                    phonenumber_options:            this.selectedSearchCase.patient_details?.phonenumber_options,
                },

                caseMethod: {
                    current_medication: null,
                    allergies: details.Allergies,
                    notes: this.selectedSearchCase.full_case_data.CaseNotes,

                    pmsCaseNumber: this.selectedSearchCase.case_number,
                    healthConcern: this.selectedSearchCase.case_title,
                    name: this.selectedSearchCase.full_name,
                    email: this.selectedSearchCase.email
                }
            };

            console.log({ form });
            this.selectedPatient = form;
        },

        /* ################################################## METHOD SEPARATORS ################################################## */

        /*convertHeightToFeet(height) {
            let realFeet = ((height*0.393700) / 12);
            let feet = Math.floor(realFeet);
            let inches = Math.round((realFeet - feet) * 12);

            return {
                feet,
                inch: inches
            };
        }*/
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    mounted() {
        this.addToFormPathLogs("searchPMS");
    }
}
</script>